import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { InboxSidebarItemData } from 'src/components/Inbox/InboxSidebar';
import { InboxPageContext } from 'src/context/inboxPageContext';
import { useUpdateInboxNotificationStatusMutation } from 'src/services/api/inboxApi';
import { ChannelListItem } from '../UI/ListItem/ChannelListItem';
import history from 'src/history';
import { Avatar } from '../UI/Avatars';
import { getInitials } from 'src/utils/UserUtils';
import { ItemRenderProps } from '../Channels/BaseChannelSidebar';
import { AvatarInfoType } from '../Channels/ChannelSidebarItem';
import { NOTIFICATIONS_STATUSES } from 'src/constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    summaryText: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: theme.spacing(0.5),
    },
    summaryAvatar: {
      height: 20,
      width: 20,
      // initials font size
      '& > *': {
        fontSize: 10,
      },
    },
  }),
);

export const InboxSidebarItem: React.FC<
  ItemRenderProps<InboxSidebarItemData>
> = (props) => {
  const { selectedNotification } = React.useContext(InboxPageContext);
  const { channelOption, onSelect } = props;
  const [markNotificationAsRead] = useUpdateInboxNotificationStatusMutation();

  const classes = useStyles();

  const { avatarInfo, isRead, title, id: notificationId } = channelOption;

  const handleChannelClicked = () => {
    history.push({
      search: `?channelId=${notificationId}`,
    });

    if (!isRead && notificationId) {
      markNotificationAsRead({
        notificationId,
        status: NOTIFICATIONS_STATUSES.READ, // read notification status
      });
    }
    onSelect(channelOption);
  };

  /**
   * This function gets the avatar variant based on the notification subtitle.
   * When the sender belongs to a company we append 'from' to the sender name
   * which is available in the avatarInfo.name property.
   * @param avatarData : sender avatar data
   * @returns avatar variant
   */
  const getAvatarVariant = (avatarData: AvatarInfoType) =>
    avatarData.isCompanyUser ? 'rounded' : 'circle';

  return (
    <ChannelListItem
      title={title}
      subTitle={
        <div className={classes.summaryText}>
          <Avatar
            className={classes.summaryAvatar}
            src={avatarInfo?.imageUrl}
            fallbackLetters={getInitials(avatarInfo?.name || '')}
            fallbackColor={avatarInfo?.fallbackColor || ''}
            variant={avatarInfo ? getAvatarVariant(avatarInfo) : 'circle'}
          />
          {avatarInfo?.name || ''}
        </div>
      }
      timestamp={channelOption.timestamp}
      selected={selectedNotification?.id === notificationId}
      onSelect={handleChannelClicked}
      unread={!isRead}
    />
  );
};
